import CategoryPostCard from 'components/blog/category-post-card'
import { fetchStrapiAPI } from 'lib/api'
import { GetServerSideProps } from 'next'
import Link from 'next/link'
import { BlogCategory, BlogPost } from 'types/strapi/blog-posts'

import * as Sentry from '@sentry/react'

type Props = {
  posts: BlogPost[]
  category: BlogCategory
}

const Post = ({ posts, category }: Props) => {
  return (
    <div className="w-full pt-16">
      <div className="mx-auto flex w-full max-w-screen-xl flex-col lg:w-4/5">
        <div className="mx-auto flex w-full max-w-screen-xl flex-row pl-5 pt-5 lg:flex-row">
          <Link href={'/'}>
            <a className="cursor-pointer text-gray-900">Home</a>
          </Link>
          <span className="px-3 font-bold text-gray-400">·</span>
          <Link href={'/blog'}>
            <a className="cursor-pointer text-gray-900">Blog</a>
          </Link>
        </div>
        <div className="flex flex-wrap items-center py-2 pl-5">
          Category:
          <span key={category.attributes.slug} className="m-2 rounded-2xl bg-gray-300 px-4 py-1">
            {category.attributes.name}
          </span>
        </div>
        {posts?.length === 0 && <p className="p-5">There is not any post for this category yet.</p>}
        <div className="grid w-full grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {posts?.map((post) => (
            <CategoryPostCard key={post.attributes.slug} post={post} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Post

export const getServerSideProps: GetServerSideProps = async (context) => {
  const slug = context.params?.slug
  if (slug) {
    try {
      const posts = await fetchStrapiAPI<BlogPost[]>(
        `/blog-posts?filters[categories][slug][$eq]=${slug}&populate=categories&populate=thumbnail&populate=squareThumbnail&sort=publishDate:desc`
      )
      const categories = await fetchStrapiAPI<BlogCategory[]>(`/blog-categories?filters[slug][$eq]=${slug}`)
      return {
        props: {
          posts: posts,
          category: categories?.[0],
        },
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      } else {
        Sentry.captureException(error)
      }
    }
  }
  return {
    props: { post: null, category: null },
  }
}
